import { Fallback } from "@/components";
import { Navigate, useLocation } from "react-router-dom";
import { useEffect, useState } from "react";

export const RequireAuth = ({ children }: React.PropsWithChildren) => {
  const { pathname } = useLocation();
  const [loading, setLoading] = useState(true);
  const [isAuthenticated, setIsAuthenticated] = useState(false);

  useEffect(() => {
    const checkAuth = async () => {
      try {
        const token = localStorage.getItem("authToken");
        setIsAuthenticated(!!token);
      } catch (error) {
        console.log(error);
        setIsAuthenticated(false);
      } finally {
        setLoading(false);
      }
    };

    checkAuth();
  }, []);

  if (!children) {
    throw new Error("Children must be provided");
  }

  if (loading) {
    return <Fallback />;
  }

  if (isAuthenticated) {
    return children as JSX.Element;
  } else {
    return <Navigate to='/login' state={{ from: pathname }} replace />;
  }
};
